import {
  TypedFormGroup,
  TypedFormControl,
  TypedFormArray,
} from '@assetaccountant/core/utils/typed-forms';

export type FieldAssignmentGroup = TypedFormGroup<{
  fieldId: TypedFormControl<string>;
  valueIdAllocations: TypedFormArray<FieldValueAllocationGroup>;
}>;

export type FieldAllocationGroup = TypedFormGroup<{
  valueIdAllocations: TypedFormArray<FieldValueAllocationGroup>;
}>;

export type FieldValueAllocationGroup = TypedFormGroup<{
  valueId: TypedFormControl<string>;
  allocation: TypedFormControl<number>;
}>;

export interface FieldAllocationValue {
  valueIdAllocations: Array<{ valueId: string; allocation: number }>;
}

/**
 * If Classification Splitting is enabled:
 * - transforms the valueIdAllocations array into a dictionary
 * - and strips out valueId/fieldValueId
 * Otherwise
 * - strips out valueIdAllocations
 */
export const withAllocationsToDictionary = <T extends FieldAllocationValue>(
  obj: T,
): Pick<T, Exclude<keyof T, 'valueIdAllocations'>> & {
  valueIdAllocations: Record<string, number>;
} => ({
  ...obj,
  valueIdAllocations: Object.fromEntries(
    obj.valueIdAllocations.filter(g => !!g.valueId).map(g => [g.valueId, g.allocation]),
  ),
});
